import { render } from "./RecipeView.vue?vue&type=template&id=76c4da72&scoped=true"
import script from "./RecipeView.vue?vue&type=script&lang=js"
export * from "./RecipeView.vue?vue&type=script&lang=js"

import "./RecipeView.vue?vue&type=style&index=0&id=76c4da72&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c4da72"]])

export default __exports__